/** biome-ignore-all lint/correctness/noUnusedImports: this is a really stupid lint thing to deal with */
import React, { type FC } from 'react'
import { type DataPointValueType, OrchestratedAgent } from '../../../../generated/types-orchestration'
import { mapFieldTypeIcon } from '../../ExtensionActivityDetail/tabs/mapFieldTypeIcon'
import { Icon, Badge, IconSize } from '@awell-health/design-system'
import { ExpandableContent } from '../../ExpandableContent'

interface Props {
  orchestrationAgent: OrchestratedAgent | null
  agentConfig: any | null
}

export const ReceivedTab: FC<Props> = ({ agentConfig, orchestrationAgent }) => {
  if (!agentConfig || !orchestrationAgent) {
    return <div>Agent not found</div>
  }

  const { output_specs } = agentConfig

  const outputsWithoutSummary = output_specs?.filter(({ name }: { name: string }) => name !== 'summary')
  const hasOutputs = outputsWithoutSummary && outputsWithoutSummary.length > 0
  return (
    <div className="flex flex-col gap-4 w-full">
      <div className="text-lg font-medium text-gray-900">Data received from the agent</div>
      <div key="fields" className="flex flex-col gap-2 w-full">
        {hasOutputs &&
          outputsWithoutSummary.map(({ name, type }: { name: string; type: DataPointValueType }) => (
            <div key={name} className="rounded-xl border p-3">
              <div className="flex flex-col gap-2">
                <Badge size={null} variant="default">
                  <Icon icon={mapFieldTypeIcon(type)} size={IconSize.xxs} className="mr-1" />
                  {name}
                </Badge>
                <ExpandableContent content={orchestrationAgent.execution.outputs[name]?.toString() ?? '-'} />
              </div>
            </div>
          ))}
        {!hasOutputs && <div className="text-sm text-slate-500">No data was received from the agent.</div>}
      </div>
    </div>
  )
}
